import { useQuery } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { appointmentApi } from "../service";

export function useAppointmentDetail(appointmentId?: number) {
  return useQuery({
    queryKey: appointmentKeys.detail(appointmentId ?? ""),
    queryFn: () => appointmentApi.getById(appointmentId!).then((r) => r.data),
    enabled: Boolean(appointmentId),
    retry: false,
  });
}
